import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link, useOutletContext } from "react-router-dom"; // Import Link

function AssetsView({ asset_id }) {
  const [assetData, setAssetData] = useState(null);

  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    if (!asset_id) return;

    const fetchAssetDetail = async () => {
      setGlobalLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/employeeinfos/getAssetDetail/${asset_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setAssetData(response.data);
        console.log(asset_id);
      } catch (error) {
        console.log(error);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchAssetDetail();
  }, [asset_id]);

  return (
    <>
      <div className="modal fade" id="asset_info" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Asset Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="bg-light p-3 rounded d-flex align-items-center mb-3">
                <span className="avatar avatar-lg flex-shrink-0 me-2">
                  <img
                    src="assets/img/laptop.jpg"
                    alt="img"
                    className="ig-fluid rounded-circle"
                  />
                </span>
                <div>
                  <h6>{assetData?.serial_no || "N/A"}</h6>
                  <p className="fs-13">
                    <span className="text-primary">AST - 001 </span>
                    <i className="ti ti-point-filled text-primary"></i>
                    {"Assigned on"} {assetData?.from || "N/A"}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Type</p>
                    <p className="text-gray-9">
                      {assetData?.assets_type || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Brand</p>
                    <p className="text-gray-9">{assetData?.make || "N/A"}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Category</p>
                    <p className="text-gray-9">
                      {assetData?.assets_type || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Serial No</p>
                    <p className="text-gray-9">
                      {assetData?.serial_no || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Cost</p>
                    <p className="text-gray-9">
                      {assetData?.assets_type || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Vendor</p>
                    <p className="text-gray-9">
                      {assetData?.assets_type || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Warranty</p>
                    <p className="text-gray-9">
                      {assetData?.assets_type || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <p className="fs-13 mb-0">Location</p>
                    <p className="text-gray-9">
                      {assetData?.assets_type || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <p className="fs-13 mb-2">Asset Images</p>
                <div className="d-flex align-items-center">
                  <img
                    src="assets/img/laptop-01.jpg"
                    alt="img"
                    className="img-fluid rounded me-2"
                  />
                  <img
                    src="assets/img/laptop-2.jpg"
                    alt="img"
                    className="img-fluid rounded me-2"
                  />
                  <img
                    src="assets/img/laptop-3.jpg"
                    alt="img"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssetsView;
